// Utils
import { CustomApiError } from "~utils/customApiError"
import { HTTP_STATUS } from "./httpStatus"

export enum ERROR_MESSAGES {
  GENERIC = "There was an error, please try again.",
  REQUIRED_COMPANY = "A company is required to perform this action.",
  // SERVER
  SERVER_ERROR = "Server error, please try again.",
  UNAUTHORIZED = "Invalid credentials, please try again.",
  FORBIDDEN = "You don't have permissions, please contact your account administrator.",
  // PASSWORDS
  PASSWORD_CONFIRM = "New password does not match with new password confirmation.",
  // FORMS
  FIELD_REQUIRED = "This field is required.",
  INVALID_EMAIL = "Invalid e-mail provided.",
  INVALID_HEX_CODE = "Invalid Hex color code.",
  INVALID_PASSWORD = "Password must be at least 8 characters and contain at least one uppercase and at least one number or symbol.",
  EXCEEDS_LIMIT = "Exceeds the limit",
  ONLY_NUMBERS = "Accept only numbers",

  // API RESPONSES
  EXISTING_COMPANY_IN_SAME_LOCATION = "You cannot use the same location as another company.",
  FETCHING_COMPANIES = "There was an error while getting the companies, please try again later or contact support",
  FETCHING_ROLES = "There was an error while getting the roles, please try again later or contact support",
}

export const HTTP_ERROR_MESSAGES = {
  [HTTP_STATUS.UNAUTHORIZED]: ERROR_MESSAGES.UNAUTHORIZED,
  [HTTP_STATUS.INTERNAL_SERVER_ERROR]: ERROR_MESSAGES.SERVER_ERROR,
  [HTTP_STATUS.FORBIDDEN]: ERROR_MESSAGES.FORBIDDEN,
}

export const GENERIC_API_FAIL_RESPONSE = (entity: string): string => {
  return `There was an error while saving the ${entity}, please try again later or contact support.`
}

export const handleApiErrorMessage = (error: any): Promise<string> => {
  const status: number = error?.status || error?.response?.status || 500

  if (!HTTP_ERROR_MESSAGES[status]) {
    return error
  }

  throw new CustomApiError(HTTP_ERROR_MESSAGES[status], status)
}
